import { enrollToCourseMockHandler } from '@/features/user-notifications/api/enroll-to-course';
import { getBatchesMockHandler } from '@/features/user-notifications/api/get-batches';
import { getMathleteBatchesMockHandler } from '@/features/user-notifications/api/get-mathlete-batches';
import { registerForMathleteBatchMockHandler } from '@/features/user-notifications/api/register-mathlete-batch';

/**
 * MSW handlers for enrollment API endpoints
 * Re-exported from the API module to keep mocks colocated
 * with their respective API definitions.
 *
 * Includes handlers for:
 * - School curriculum enrollment
 * - NAPLAN enrollment and batches
 * - IMO enrollment
 * - Mathlete registration and batches
 */
export const enrollmentsHandlers = [
  enrollToCourseMockHandler,
  getBatchesMockHandler,
  getMathleteBatchesMockHandler,
  registerForMathleteBatchMockHandler,
];
